import { Alert, Avatar, Box, Chip, CircularProgress, Container, Divider, Fab, FormControl, Grid, Grow, Icon, InputAdornment, InputLabel, LinearProgress, MenuItem, OutlinedInput, Paper, Select, Snackbar, StepLabel, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import CalculateIcon from '@mui/icons-material/Calculate';
import ApointmentModal from '../components/general/ApointmentModal';
import RequestModal from '../components/general/RequestModal';
import { getAllCredits, getCreditResults } from '../services/CreditService';
import CalendarIcon from '../static/icons/enlinea_01.png'
import PrintIcon from '../static/icons/enlinea_02.png'
import { SECONDARY_COLOR, MAIN_COLOR } from '../utils/constants';
import { ProductContext } from '../contexts/GeneralContexts';
import CreditResultsModal from '../components/general/CreditResultsModal';
import "../assets/styles/CalculatorStyle.css";
import { useMediaQuery } from '@mui/material';

export default function Calculator() {
    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.down("xs"));
    const [openModalApointment, setopenModalApointment] = useState(false)
    const [openModalRequest, setopenModalRequest] = useState(false)
    const [openModalCreditResults, setopenModalCreditResults] = useState(false)

    const [products, setproducts] = useState<any>([])
    const [boolLimite, setboolLimite] = useState(false)
    const [selectedProduct, setselectedProduct] = useState<any>({})
    const [creditResults, setcreditResults] = useState<any>({})
    const [periodicity, setperiodicity] = useState({
        value: 0,
        name: '',
        pluralName: '',
        id: 0
    })
    const [loaderResult, setloaderResult] = useState(false)
    const [boolError, setboolError] = useState(false)
    const [boolLock, setboolLock] = useState(true)
    const [boolAlert, setboolAlert] = useState(false)
    const [meet, setmeet] = useState({})
    const [selectedPlazo, setselectedPlazo] = useState("")

    const firstFabRef = useRef<any>();

    const productContext = useContext(ProductContext);

    const formatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
    });

    const getProducts = async () => {
        const response = await getAllCredits()

        if (response.status == 200) {
            setproducts(response.data.filter((r: any) => r.product.producttype.id === 2))
            setselectedProduct({
                ...response.data[0],
                cantidad: response.data[0].min
            })
            await obtenerResultadosIniciales(response.data[0])
        }

    }

    const filtrarProductos = async (name: any) => {
        const txt = document.getElementById("txtCantidad")
        if (txt)
            txt.style.color = SECONDARY_COLOR

        const aux = products.filter((p: any) => p.product.title === name)

        setselectedProduct({
            ...aux[0],
            cantidad: aux[0].min
        })
        setselectedPlazo(aux[0].rangetimecreditList[0].id)
        setperiodicity({
            value: aux[0].rangetimecreditList[0].rangetime.value,
            name: aux[0].rangetimecreditList[0].rangetime.periodicity.name,
            pluralName: aux[0].rangetimecreditList[0].rangetime.periodicity.pluralName,
            id: aux[0].rangetimecreditList[0].idrangetime
        })
        setboolError(false)
    }

    const validarCantidad = (cant: number) => {
        const txt = document.getElementById("txtCantidad")
        if (cant > selectedProduct.max || cant < selectedProduct.min) {
            if (txt)
                txt.style.color = MAIN_COLOR

            setselectedProduct({
                ...selectedProduct,
                cantidad: cant
            })
            setboolLimite(true)
        }
        else {
            if (txt)
                txt.style.color = SECONDARY_COLOR
            setboolLimite(false)
            setboolError(false)
            setselectedProduct({
                ...selectedProduct,
                cantidad: cant
            })
        }
    }

    const obtenerResultados = async (p: any) => {
        try {
            setloaderResult(true)
            const response = await getCreditResults(p.id, periodicity.id, p.cantidad)

            if (response.status === 200) {
                setcreditResults(response.data)
                setloaderResult(false)
                setboolLock(false)
                setboolError(false)
            } else {
                setloaderResult(false)
            }
        } catch (error) {
            setboolError(true)
            setloaderResult(false)
        }
    }

    const recalcularResultados = async (p: any) => {
        try {
            setselectedPlazo(p.id)
            setloaderResult(true)
            setperiodicity({
                value: p.rangetime.value,
                name: p.rangetime.periodicity.name,
                pluralName: p.rangetime.periodicity.pluralName,
                id: p.idrangetime
            })
            const response = await getCreditResults(selectedProduct.id, p.idrangetime, selectedProduct.cantidad)

            if (response.status === 200) {
                setcreditResults(response.data)
                setloaderResult(false)
                setboolLock(false)
                setboolError(false)
            } else {
                setloaderResult(false)
            }
        } catch (error) {
            setboolError(true)
            setloaderResult(false)
        }
    }

    const obtenerResultadosIniciales = async (p: any) => {
        try {
            setloaderResult(true)
            setperiodicity({
                value: p.rangetimecreditList[0].rangetime.value,
                name: p.rangetimecreditList[0].rangetime.periodicity.name,
                pluralName: p.rangetimecreditList[0].rangetime.periodicity.pluralName,
                id: p.rangetimecreditList[0].idrangetime
            })

            const response = await getCreditResults(p.id, p.rangetimecreditList[0].idrangetime, p.min)

            if (response.status === 200) {
                setcreditResults(response.data)
                setloaderResult(false)
                setboolLock(false)
                setboolError(false)
            } else {
                setloaderResult(false)
            }
        } catch (error) {
            setboolError(true)
            setloaderResult(false)
        }
    }

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setboolAlert(false);
    };

    /* const handleKeyPress = (e: any) => {
        console.log(e)
        const pattern = /^[0-9\b]+$/; // Only allow numeric values and backspace (\b)
        const keyPressed = String.fromCharCode(e.keyCode || e.which);
      
        if (!pattern.test(keyPressed)) {
          e.preventDefault(); // Prevent the input of non-numeric values
        }
      }; */

    useEffect(() => {
        getProducts()
    }, [])

    useEffect(() => {
        obtenerResultados(selectedProduct)
    }, [selectedProduct])

    useEffect(() => {
        if (firstFabRef.current) {
            firstFabRef.current.focus()
        }

    }, []);


    useEffect(() => {
        if (Object.keys(productContext[0]).length !== 0) {
            setselectedProduct({ ...productContext[0], cantidad: productContext[0].min })
            setperiodicity({
                value: productContext[0].rangetimecreditList[0].rangetime.value,
                pluralName: productContext[0].rangetimecreditList[0].rangetime.periodicity.pluralName,
                name: productContext[0].rangetimecreditList[0].rangetime.periodicity.name,
                    id: productContext[0].rangetimecreditList[0].idrangetime
            })
            const element = document.getElementById("calculator")

            if (Object.keys(selectedProduct).length !== 0)
                element?.scrollIntoView({ behavior: 'smooth' })
        }
    }, [productContext])

    return (
        <Container sx={{ p: 1 }} id="calculator">
            <Grid container spacing={1}>
                <Grid item xs={12} md={8} lg={8}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', textAlign: 'start', padding: { md: 6, sm: 4, xs: 1 },
                        borderRadius: '30px', backgroundColor: 'rgba(0,0,0,0,0.5)', backgroundImage: 'linear-gradient(to bottom right, rgba(255,255,255,0.7), rgba(255,255,255,0.6))'
                        , backdropFilter: 'blur(10px)', boxShadow: '10 10 10 rgba(30,30,30,0.5)'
                    }}>
                        <Grid container sx={{display:'flex', alignItems:'center'}}>
                            <Grid item md={"auto"} alignSelf="center">
                                <CalculateIcon sx={{ color: '#ff1719', width: { md: '70px', sm: '50px', xs: '50px' }, height: { md: '70px', sm: '50px', xs: '50px' }, mt: { xs: 1 } }}></CalculateIcon>
                            </Grid>
                            <Grid item md={10}>
                                <h4 className='calculator-title'>Simula tu <b style={{ color: `${SECONDARY_COLOR}` }}>Crédito</b></h4>
                            </Grid>
                        </Grid>
                        <FormControl variant="standard" sx={{ m: 1, maxWidth: 350, mt: 3 }}>
                            <InputLabel id="demo-simple-select-standard-label" sx={{ fontSize: 20, color: 'black' }}>Selecciona tu crédito</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Selecciona tu crédito"
                                sx={{ fontWeight: 'bold', fontSize: 18 }}
                                value={selectedProduct.product ? selectedProduct?.product.title : ""}
                                onChange={e => filtrarProductos(e.target.value)}
                                error
                            >
                                {
                                    products.map((p: any) => (
                                        <MenuItem key={p.id} value={p.product.title} sx={{ fontWeight: 'bold' }}>{p.product.title}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl> <br></br>
                        <FormControl sx={{ m: 1, maxWidth: 350 }}>
                            <InputLabel htmlFor="outlined-adornment-amount" sx={{ color: 'black' }}>Introduce una cantidad</InputLabel>
                            <OutlinedInput
                                size='medium'
                                value={selectedProduct.product && selectedProduct.cantidad}
                                id="txtCantidad"
                                type='number'
                                sx={{ fontWeight: 'bold', fontSize: 20 }}
                                onChange={(e: any) => validarCantidad(+e.target.value)}
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Introduce una cantidad"
                            />
                            {
                                boolLimite && <StepLabel sx={{ margin: 1 }} color={MAIN_COLOR}> Monto mínimo: <b>{formatter.format(selectedProduct.min)}</b> <br />*Monto máximo: <b>{formatter.format(selectedProduct.max)}</b></StepLabel>
                            }
                            {
                                boolError && <Alert variant="outlined" severity="error" sx={{ marginTop: 1 }}>
                                    ¡Vuelva a escribir la cantidad!
                                </Alert>
                            }
                        </FormControl>

                        <Box display="flex" flexDirection="row">
                            <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: 18 }}>Elige un plazo</Typography>
                            {
                                selectedProduct.periodicity && <Chip label={selectedProduct.periodicity === "Mes" ? "Meses" : "Quincenas"} sx={{ backgroundColor: `${MAIN_COLOR}`, color: 'white', marginLeft: 1, fontWeight: 'bold' }} size='small'></Chip>
                            }
                        </Box>
                        <Divider></Divider>
                        <br />
                        <Box display="flex" flexDirection="row" justifyContent="space-evenly" width='100%'>
                            {
                                Object.keys(selectedProduct).length !== 0 && selectedProduct.hasOwnProperty('rangetimecreditList')
                                    ? selectedProduct.rangetimecreditList.sort((a:any, b:any) => a.rangetime.value - b.rangetime.value).map((r: any, index: number) => (
                                        <Fab
                                            ref={index === 0 ? firstFabRef : null}
                                            key={r.id}
                                            size="large"
                                            sx={{
                                                background: selectedPlazo === r.id ? `${SECONDARY_COLOR}` : `${MAIN_COLOR}`, color: 'white', fontSize: 19, fontWeight: 'bold',
                                                ":hover": { color: 'red', transform:'scale(1.2)', transition:'0.4s' }
                                            }} onClick={() => recalcularResultados(r)}>{r.rangetime.value}</Fab>
                                    )) : <Typography fontWeight="bold" color="red" >Seleccione un producto para visualizar plazos</Typography>
                            }
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} md={4} lg={4} alignSelf="center">
                    <Paper elevation={3} sx={{
                        display: 'flex', flexDirection: 'column', textAlign: 'start', padding: 6,
                        borderRadius: '30px', background: 'rgba(244, 244, 244, 1)', backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)',
                        border: '1px solid rgba( 255, 255, 255, 0.18 )'
                    }}>
                        <Grid container height="100%">
                            {
                                selectedProduct.cantidad >= selectedProduct.min && selectedProduct.cantidad <= selectedProduct.max ?
                                    <>
                                        {/* <Grid item xs={12} md={6} alignSelf="center">
                                            <Typography variant="h5">Tasa de interés anual fija</Typography>
                                            <b style={{ fontSize: 30 }}>{!loaderResult ? creditResults.rate ? creditResults.rate : 0 : <CircularProgress color='error'></CircularProgress>}%</b>
                                        </Grid> */}
                                        <Grid item xs={12} md={12} alignSelf="center" textAlign="center">
                                            <Typography variant="h5" >Pagarías</Typography>
                                            <b style={{ fontSize: 32 }}>{!loaderResult ? formatter.format(creditResults.pago ? creditResults.pago.pago : 0) : <CircularProgress color='error'></CircularProgress>}</b>
                                            <Typography variant="h5" >por {periodicity.value} {periodicity.value === 1 ? periodicity.name : periodicity.pluralName}</Typography>
                                        </Grid></> :
                                    <Typography fontWeight={600} variant="h5" color={`${SECONDARY_COLOR}`}>Asegúrate de estar dentro de las cantidades permitidas</Typography>
                            }


                        </Grid>
                    </Paper>

                    <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: "center" }} mt={5}>
                        <Avatar
                            sx={{ width: 50, height: 50, cursor: 'pointer', '&:hover': { transform: 'scale(1.3)' }, transition: '0.2s', m: 1 }}
                            onClick={() => setopenModalApointment(true)}
                            alt="calendar icon"
                            src={`${CalendarIcon}`} />
                        <Tooltip title={boolLimite ? "Favor de corregir la cantidad solicitada." : "Dar click para generar la tabla de amortización del crédito seleccionado"}>
                            <Avatar
                                hidden={boolLimite}
                                sx={{ width: 50, height: 50, cursor: 'pointer', '&:hover': { transform: 'scale(1.2)' }, transition: '0.1s', m: 1 }}
                                onClick={() => {
                                    if (boolLimite !== true)
                                        setopenModalCreditResults(true)
                                }}
                                alt="print icon"
                                src={`${PrintIcon}`} />
                        </Tooltip>

                        <Fab variant="extended" sx={{ background: '#ff1719', color: 'white', textTransform: 'none', ':hover': { color: `${MAIN_COLOR}` } }} onClick={() => setopenModalRequest(true)} disabled={boolLimite || boolLock}>Obtener en línea</Fab>
                    </Grid>
                </Grid>

                <Grid item xs={12} display="flex" flexDirection="column" alignItems="center" marginTop={3} padding={2} sx={{
                    borderRadius: '15px', backgroundColor: 'rgba(0,0,0,0,0.5)', backgroundImage: 'linear-gradient(to bottom right, rgba(255,255,255,0.7), rgba(255,255,255,0.7))'
                    , backdropFilter: 'blur(10px)', boxShadow: '10 10 10 rgba(30,30,30,0.7)'
                }}>
                    <Typography variant="body1" fontWeight={700} color={`${MAIN_COLOR}`}>*límite sujeto a políticas de crédito y autorización del Comité de Crédito</Typography>
                    <Typography variant="body2" textAlign="justify">Condiciones sujetas a políticas de crédito vigente y de acuerdo a las condiciones específicas del producto
                        "{selectedProduct.product?.name}". <b style={{ fontSize: 23 }}>CAT PROMEDIO {creditResults.catX}% Sin IVA. CAT (Costo Anual Total).</b> Para fines informativos y de comparación, fecha de cálculo {new Intl.DateTimeFormat("es-ES", {
                            weekday: "long",
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                        }).format(new Date())}
                        , para un crédito de {formatter.format(+selectedProduct?.cantidad || 0)} pesos a un plazo de {periodicity.value} {periodicity.pluralName} y tasa fija del {selectedProduct?.rate}% anual. Vigencia al {new Intl.DateTimeFormat("es-ES", {
                            weekday: "long",
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                        }).format(new Date())}. Cobertura Nacional.
                        Sujeto a aprobación de crédito. Los datos que se muestran no corresponden a una cotización oficial, es únicamente una referencia de simulación de crédito.
                        Sujeto a cambios sin previo aviso. Informes sobre requisitos, términos, comisiones y condiciones de contratación del producto: www.avantthya.com.mx</Typography>
                </Grid>
            </Grid>

            <Snackbar open={boolAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} variant="filled" severity="success">¡Has enviado tu cotización de crédito con éxito! Nos pondremos en contacto contigo lo antes posible.</Alert>
            </Snackbar>


            <ApointmentModal
                open={openModalApointment}
                close={() => { setopenModalApointment(false) }}
                setMeeting={(e: any) => setmeet(e)}
                closeWithResponse={(e: any) => { if (e === true) setopenModalRequest(true) }}></ApointmentModal>
            <RequestModal
                products={products}
                periodicity={periodicity}
                meet={meet}
                product={Object.keys(selectedProduct).length !== 0 && selectedProduct}
                open={openModalRequest}
                close={() => setopenModalRequest(false)}
                closeWithResponse={(e: any) => { if (e === true) setboolAlert(true) }}></RequestModal>
            <CreditResultsModal
                credit={creditResults}
                product={Object.keys(selectedProduct).length !== 0 && selectedProduct}
                periodicity={periodicity}
                open={openModalCreditResults}
                close={() => setopenModalCreditResults(false)}></CreditResultsModal>
        </Container >
    )
}
